// extracted by mini-css-extract-plugin
export default {"dividerContainer":"Divider_dividerContainer__Y+fuV","divider":"Divider_divider__mK6sR"};